import { useEffect, useRef } from 'react';

export const POLL_MS = 2000;
export const POLL_MAX_HIDDEN_MS = 60000;

/**
 * Pollingintervall für TanStack Query: sichtbarer Tab alle 2 s, inaktiver Tab mit
 * exponentiellem Backoff bis 60 s (03 „Eigene API“). Rückgabe false = kein Polling.
 */
export function useBackoffInterval(active: boolean, baseMs = POLL_MS) {
  const hiddenPolls = useRef(0);
  useEffect(() => {
    const onVis = () => {
      if (!document.hidden) hiddenPolls.current = 0;
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, []);
  return () => {
    if (!active) return false as const;
    return nextInterval(document.hidden, hiddenPolls, baseMs);
  };
}

export function nextInterval(hidden: boolean, counter: { current: number }, baseMs = POLL_MS): number {
  if (!hidden) {
    counter.current = 0;
    return baseMs;
  }
  counter.current += 1;
  return Math.min(POLL_MAX_HIDDEN_MS, baseMs * 2 ** counter.current);
}
